import { ChangeDetectionStrategy, Component, inject, input, output, viewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';

import { animateText } from '../main-nav-animations';
import { SimpleNavLink } from './nav-link';
import { MainNavService } from '../main-nav.service';
import { Router, RouterLinkActive } from '@angular/router';
import { MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-nav-link',
  templateUrl: './nav-link.component.html',
  styleUrl: './nav-link.component.scss',
  animations: [animateText],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListItem, RouterLinkActive, MatIcon],
})
export class NavLinkComponent {
  mainNavService = inject(MainNavService);
  private route = inject(Router);

  readonly accordion = viewChild(MatAccordion);
  readonly closeDrawer = output();
  readonly linkData = input<SimpleNavLink>();
  readonly sectionLink = input(false);

  public routeTo(path: string | null) {
    if (path) {
      this.closeDrawer.emit();
      void this.route.navigate([path]);
    }
  }
}
